export default __webpack_public_path__ + "static/media/telegram.5cfec89a.svg";